import { createAsyncThunk } from '@reduxjs/toolkit';
import { ILinkAssetType } from '__generated__/api';
import { IBondGelemReport, SELECT_BOND_GELEM_REPORT } from 'services/bonds-helper';
import { multiplyBondRowItems } from 'utils/bonds';
import { dateFormat } from 'utils/dates';
import { API, parseErrorData } from 'utils/service';
import { AppAsyncThunkConfig } from '../index';
import { PREFIX } from './helpers';
import { selectorsReportYieldShekel } from './selectors';

export const actionReportYieldShekelFetch = createAsyncThunk<
  Array<IBondGelemReport>,
  void | { initDate: string },
  AppAsyncThunkConfig
>(`${PREFIX}/actionReportYieldShekelFetch`, async (_, { getState }) => {
  try {
    const { date } = selectorsReportYieldShekel.filters(getState());
    const { data } = await API.api.bondsHelperGetGelemBondItemsDynamicCreate({
      select: SELECT_BOND_GELEM_REPORT,
      date: dateFormat(date, 'yyyy-MM-dd'),
      linkAssetType: ILinkAssetType.ILS,
    });

    return data.items.map(multiplyBondRowItems) as unknown as Array<IBondGelemReport>;
  } catch (e: unknown) {
    throw parseErrorData(e);
  }
});
